/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetDiscordChannels,
  FleetDiscordRoleMappings,
  FleetDiscordRoleMappingsUpdateInput,
  FleetDiscordRoles,
  FleetNotificationDiscordStatus,
  FleetNotificationSetting,
  FleetNotificationSettingUpdateInput,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Fleet Discord Channels
 */
export const fleetDiscordChannels = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<FleetDiscordChannels>(
      {url: `/fleets/${fleetSlug}/discord-channels`, method: 'GET', signal
    },
      );
    }




export const getFleetDiscordChannelsQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'discord-channels'
    ] as const;
    }


export const getFleetDiscordChannelsQueryOptions = <TData = Awaited<ReturnType<typeof fleetDiscordChannels>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetDiscordChannels>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetDiscordChannelsQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetDiscordChannels>>> = ({ signal }) => fleetDiscordChannels(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetDiscordChannels>>, TError, TData>
}

export type FleetDiscordChannelsQueryResult = NonNullable<Awaited<ReturnType<typeof fleetDiscordChannels>>>
export type FleetDiscordChannelsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Discord Channels
 */

export function useFleetDiscordChannels<TData = Awaited<ReturnType<typeof fleetDiscordChannels>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetDiscordChannels>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetDiscordChannelsQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Fleet Discord Role Mappings
 */
export const fleetDiscordRoleMappings = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<FleetDiscordRoleMappings>(
      {url: `/fleets/${fleetSlug}/discord-role-mappings`, method: 'GET', signal
    },
      );
    }




export const getFleetDiscordRoleMappingsQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'discord-role-mappings'
    ] as const;
    }


export const getFleetDiscordRoleMappingsQueryOptions = <TData = Awaited<ReturnType<typeof fleetDiscordRoleMappings>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetDiscordRoleMappings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetDiscordRoleMappingsQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetDiscordRoleMappings>>> = ({ signal }) => fleetDiscordRoleMappings(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetDiscordRoleMappings>>, TError, TData>
}

export type FleetDiscordRoleMappingsQueryResult = NonNullable<Awaited<ReturnType<typeof fleetDiscordRoleMappings>>>
export type FleetDiscordRoleMappingsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Discord Role Mappings
 */

export function useFleetDiscordRoleMappings<TData = Awaited<ReturnType<typeof fleetDiscordRoleMappings>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetDiscordRoleMappings>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetDiscordRoleMappingsQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Fleet Discord Role Mappings
 */
export const updateFleetDiscordRoleMappings = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetDiscordRoleMappingsUpdateInput: MaybeRefOrGetter<FleetDiscordRoleMappingsUpdateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetDiscordRoleMappingsUpdateInput = toValue(fleetDiscordRoleMappingsUpdateInput);

      return axiosClient<FleetDiscordRoleMappings>(
      {url: `/fleets/${fleetSlug}/discord-role-mappings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fleetDiscordRoleMappingsUpdateInput, signal
    },
      );
    }




export const getUpdateFleetDiscordRoleMappingsMutationKey = () => ['updateFleetDiscordRoleMappings'] as const;

export const getUpdateFleetDiscordRoleMappingsMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetDiscordRoleMappings>>, TError,UpdateFleetDiscordRoleMappingsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetDiscordRoleMappings>>, TError,UpdateFleetDiscordRoleMappingsMutationVariables, TContext> => {

const mutationKey = getUpdateFleetDiscordRoleMappingsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetDiscordRoleMappings>>, UpdateFleetDiscordRoleMappingsMutationVariables> = (props) => {
          const {fleetSlug,data} = props ?? {};

          return  updateFleetDiscordRoleMappings(fleetSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetDiscordRoleMappingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetDiscordRoleMappings>>>
    export type UpdateFleetDiscordRoleMappingsMutationBody = FleetDiscordRoleMappingsUpdateInput
    export type UpdateFleetDiscordRoleMappingsMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateFleetDiscordRoleMappingsMutationVariables = {fleetSlug: string;data: FleetDiscordRoleMappingsUpdateInput}

    /**
 * @summary Update Fleet Discord Role Mappings
 */
export const useUpdateFleetDiscordRoleMappings = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetDiscordRoleMappings>>, TError,UpdateFleetDiscordRoleMappingsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetDiscordRoleMappings>>,
        TError,
        UpdateFleetDiscordRoleMappingsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFleetDiscordRoleMappingsMutationOptions(options), queryClient);
    }
    /**
 * @summary Fleet Discord Roles
 */
export const fleetDiscordRoles = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<FleetDiscordRoles>(
      {url: `/fleets/${fleetSlug}/discord-roles`, method: 'GET', signal
    },
      );
    }




export const getFleetDiscordRolesQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'discord-roles'
    ] as const;
    }


export const getFleetDiscordRolesQueryOptions = <TData = Awaited<ReturnType<typeof fleetDiscordRoles>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetDiscordRoles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetDiscordRolesQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetDiscordRoles>>> = ({ signal }) => fleetDiscordRoles(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetDiscordRoles>>, TError, TData>
}

export type FleetDiscordRolesQueryResult = NonNullable<Awaited<ReturnType<typeof fleetDiscordRoles>>>
export type FleetDiscordRolesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Discord Roles
 */

export function useFleetDiscordRoles<TData = Awaited<ReturnType<typeof fleetDiscordRoles>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetDiscordRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetDiscordRolesQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Show fleet notification settings
 */
export const fleetNotificationSetting = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<FleetNotificationSetting>(
      {url: `/fleets/${fleetSlug}/notifications`, method: 'GET', signal
    },
      );
    }




export const getFleetNotificationSettingQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'notifications'
    ] as const;
    }


export const getFleetNotificationSettingQueryOptions = <TData = Awaited<ReturnType<typeof fleetNotificationSetting>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetNotificationSetting>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetNotificationSettingQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetNotificationSetting>>> = ({ signal }) => fleetNotificationSetting(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetNotificationSetting>>, TError, TData>
}

export type FleetNotificationSettingQueryResult = NonNullable<Awaited<ReturnType<typeof fleetNotificationSetting>>>
export type FleetNotificationSettingQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Show fleet notification settings
 */

export function useFleetNotificationSetting<TData = Awaited<ReturnType<typeof fleetNotificationSetting>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetNotificationSetting>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetNotificationSettingQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update fleet notification settings
 */
export const updateFleetNotificationSetting = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetNotificationSettingUpdateInput: MaybeRefOrGetter<FleetNotificationSettingUpdateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetNotificationSettingUpdateInput = toValue(fleetNotificationSettingUpdateInput);

      return axiosClient<FleetNotificationSetting>(
      {url: `/fleets/${fleetSlug}/notifications`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: fleetNotificationSettingUpdateInput, signal
    },
      );
    }




export const getUpdateFleetNotificationSettingMutationKey = () => ['updateFleetNotificationSetting'] as const;

export const getUpdateFleetNotificationSettingMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetNotificationSetting>>, TError,UpdateFleetNotificationSettingMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetNotificationSetting>>, TError,UpdateFleetNotificationSettingMutationVariables, TContext> => {

const mutationKey = getUpdateFleetNotificationSettingMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetNotificationSetting>>, UpdateFleetNotificationSettingMutationVariables> = (props) => {
          const {fleetSlug,data} = props ?? {};

          return  updateFleetNotificationSetting(fleetSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetNotificationSettingMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetNotificationSetting>>>
    export type UpdateFleetNotificationSettingMutationBody = FleetNotificationSettingUpdateInput
    export type UpdateFleetNotificationSettingMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateFleetNotificationSettingMutationVariables = {fleetSlug: string;data: FleetNotificationSettingUpdateInput}

    /**
 * @summary Update fleet notification settings
 */
export const useUpdateFleetNotificationSetting = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetNotificationSetting>>, TError,UpdateFleetNotificationSettingMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetNotificationSetting>>,
        TError,
        UpdateFleetNotificationSettingMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFleetNotificationSettingMutationOptions(options), queryClient);
    }
    /**
 * @summary Probe the fleet's Discord guild binding
 */
export const fleetNotificationDiscordStatus = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<FleetNotificationDiscordStatus>(
      {url: `/fleets/${fleetSlug}/notifications/discord-status`, method: 'GET', signal
    },
      );
    }




export const getFleetNotificationDiscordStatusQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'notifications','discord-status'
    ] as const;
    }


export const getFleetNotificationDiscordStatusQueryOptions = <TData = Awaited<ReturnType<typeof fleetNotificationDiscordStatus>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetNotificationDiscordStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetNotificationDiscordStatusQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetNotificationDiscordStatus>>> = ({ signal }) => fleetNotificationDiscordStatus(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetNotificationDiscordStatus>>, TError, TData>
}

export type FleetNotificationDiscordStatusQueryResult = NonNullable<Awaited<ReturnType<typeof fleetNotificationDiscordStatus>>>
export type FleetNotificationDiscordStatusQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Probe the fleet's Discord guild binding
 */

export function useFleetNotificationDiscordStatus<TData = Awaited<ReturnType<typeof fleetNotificationDiscordStatus>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetNotificationDiscordStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetNotificationDiscordStatusQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






